export const nameErrorType = 'nameEmpty'

export const descriptionRows = 3
